import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-3">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-xl blur-md opacity-50"></div>
          <div className="relative w-12 h-12 rounded-xl bg-gradient-to-br from-teal-500 via-emerald-500 to-teal-600 flex items-center justify-center shadow-lg">
            <Icon name="User" size={22} color="white" />
          </div>
        </div>
        <h1 className="text-3xl font-bold bg-gradient-to-r from-teal-600 via-emerald-600 to-teal-700 bg-clip-text text-transparent">
          Welcome back
        </h1>
      </div>
      <p className="text-gray-600 text-base">
        Sign in to manage your community savings and contributions
      </p>
    </div>
  );
};

export default LoginHeader;